export default __webpack_public_path__ + "static/192-16325d0e88b4cdec142e6ec461941216.jpg";